import { render, staticRenderFns } from "./QuestionTopicExperts.vue?vue&type=template&id=ad044f00&"
import script from "./QuestionTopicExperts.vue?vue&type=script&lang=js&"
export * from "./QuestionTopicExperts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports